import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const metaServices = {
  addNewMetadata,
  updatedMetadata,
  softDeleteRestoreMetadata,
  deleteMetadata,
  getMetadataList,
  getSingleMetadata
};

// Add New Metadata
async function addNewMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewMetadata`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Metadata
async function updatedMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedMetadata`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Metadata
async function softDeleteRestoreMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreMetadata`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Metadata
async function deleteMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteMetadata`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Metadata
async function getMetadataList(status, categoryId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getMetadataList/${status}/${categoryId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getMetadataList/${status}/${categoryId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get All Metadata
async function getSingleMetadata(metaId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleMetadata/${metaId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}